import { HttpApi } from 'effect/unstable/httpapi';
import { BillingApiGroup } from './billing.js';
import { JobsApiGroup } from './jobs.js';
import { ParseApiGroup } from './parse.js';

/** One small hosted core: submit parse work, observe it through jobs, pay for it through billing. */
export const OkraApi = HttpApi.make('okra')
  .add(ParseApiGroup)
  .add(JobsApiGroup)
  .add(BillingApiGroup);
